/**
 * BMI Shortcode toggle functionality
 *
 * @package PPD
 * @since   1.0.0
 */

import $ from "jquery";

// set up the bmi calculator stuff rather than have that sitting in the block itself.
function bmiFilterShortcode() {
	$(".bmi_filter_shortcode .bmi-calc-text, .bmi_filter_shortcode i").on(
		"click",
		() => {
			$(".bmi_filter_shortcode .bmi-calc-filter").toggleClass("active");
		}
	);
	$(".bmi_filter_shortcode .bmi-calc-button").on("click", () => {
		calculateBMI();
	});
}
function calculateBMI() {
	var height_feet = eval(document.shortcode_form.feet.value);
	if (height_feet != undefined) {
		$("input#feet").removeClass("bmi-error");
	} else {
		$("input#feet").addClass("bmi-error");
	}
	var height_inches = eval(document.shortcode_form.inches.value);
	if (height_inches != undefined) {
		$("input#inches").removeClass("bmi-error");
	} else {
		$("input#inches").addClass("bmi-error");
	}
	var pounds = eval(document.shortcode_form.weight.value);
	if (pounds != undefined) {
		$("input#weight").removeClass("bmi-error");
	} else {
		$("input#weight").addClass("bmi-error");
	}

	if (
		height_feet != undefined &&
		pounds != undefined &&
		height_inches != undefined
	) {
		$(".bmi_filter_shortcode .bmi-calc-filter").removeClass("bmi-error");
		var height = height_feet * 12 + height_inches;
		var bmi = (pounds * 703) / (height * height);
		document.getElementById("shortcode_formbmi").textContent = custRound(
			bmi,
			1
		);
		$(".bmi_filter_shortcode .bmi-calc-result").toggleClass("calculated");
	} else {
		$(".bmi_filter_shortcode .bmi-calc-filter").addClass("bmi-error");
		$(".bmi_filter_shortcode .bmi-calc-result").removeClass("calculated");
	}
}

function custRound(x, places) {
	return Math.round(x * Math.pow(10, places)) / Math.pow(10, places);
}

$(document).on("click", function (e) {
	if ($(".bmi_filter_shortcode .bmi-calc-filter").hasClass("active")) {
		if (!$(e.target).is(".bmi_filter_shortcode, .bmi_filter_shortcode *")) {
			$(".bmi_filter_shortcode .bmi-calc-filter").removeClass("active");
			$(".bmi_filter_shortcode .bmi-calc-result").removeClass("calculated");
		}
	}
});

(function ($) {
	// To prevent errors on other pages, only run this script on pages where the shortcode lives.
	if (document.querySelector(".bmi_filter_shortcode")) {
		document.addEventListener("DOMContentLoaded", bmiFilterShortcode);
	}
})(jQuery);
